import { Flex } from "@hackthenorth/north";
import { Bars4Icon, CalendarIcon } from "@heroicons/react/24/outline";
import { Button } from "north.js";
import React from "react";

import { SCHEDULE_VIEW_TYPE } from "../constants";

const ScheduleToggle = ({
  currentView,
  onToggle,
}: {
  currentView: SCHEDULE_VIEW_TYPE;
  onToggle: (view: SCHEDULE_VIEW_TYPE) => void;
}) => {
  return (
    <Flex>
      <Button
        size="md"
        color={
          currentView === SCHEDULE_VIEW_TYPE.LIST_VIEW ? "primary" : undefined
        }
        style={{
          borderRadius: "4px 0px 0px 4px",
        }}
        onClick={() => onToggle(SCHEDULE_VIEW_TYPE.LIST_VIEW)}
      >
        <Bars4Icon
          style={{ height: 16, width: 16 }}
          color={
            currentView === SCHEDULE_VIEW_TYPE.LIST_VIEW
              ? "white"
              : "brandPrimary"
          }
        />
        <p>List</p>
      </Button>
      <Button
        size="md"
        color={
          currentView === SCHEDULE_VIEW_TYPE.CALENDAR_VIEW
            ? "primary"
            : undefined
        }
        style={{
          borderRadius: "0px 4px 4px 0px",
        }}
        onClick={() => onToggle(SCHEDULE_VIEW_TYPE.CALENDAR_VIEW)}
      >
        <CalendarIcon
          style={{ height: 16, width: 16 }}
          color={
            currentView === SCHEDULE_VIEW_TYPE.CALENDAR_VIEW
              ? "white"
              : "brandPrimary"
          }
        />
        <p>Calendar</p>
      </Button>
    </Flex>
  );
};

export default ScheduleToggle;
